import { API_MAP, agent } from 'helpers';
class DownloadService {
  static downloadFile(hash: string) {
    return agent.get(`${API_MAP.downloadFile}/${hash}`);
  }

  static validateDownloadHash(hash: string) {
    return agent.post(`${API_MAP.validateDownloadHash}`, { hash });
  }
}
export default DownloadService;
